import config from '@project/config';
import { PaginatedNameFilterOptions } from '@project/types';

const baseUrl = `${config.apiUrl()}/BackOffice/MunicipalityBlacklist`;

export default {
  getBaseUrl: (): string => `${baseUrl}`,
  deleteUrl: (municipalityBlackListId: string) => `${baseUrl}/${municipalityBlackListId}`,
  getPaginatedBlackListUrl: (filterOptions: PaginatedNameFilterOptions) =>
    `${baseUrl}?PageNumber=${filterOptions.pageNum}&PageSize=${filterOptions.pageEntries}&Name=${filterOptions.name}`,
};
